import { Button, Grid } from "@material-ui/core";
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import ShimmerLoader from "components/ShimmerLoader/ShimmerLoader";
import { vendorContactStyle } from './style';
import { useGetVendorContactQuery } from "./vendorContactSlice";
import { VendorContact } from "./VendorContact";
import UpdateContactDialog from "./UpdateContactDialog";
import { useState } from "react";
import { vendorContactTypes } from "features/vms/consts";
import { orderBy } from "lodash";

export const VendorContactList = ({ vendor }) => {
    const classes = vendorContactStyle();
    let { data: vendorContact, error, isLoading: isLoadingVendorContact } = useGetVendorContactQuery(vendor?.id, { skip: !vendor?.id });
    vendorContact = vendorContact || []
    vendorContact = orderBy(vendorContact, 'type')

    const hasPrimaryContact = vendorContact?.some(contact => contact.type === vendorContactTypes.PRIMARY);

    const [openUpdateDialog, setOpenUpdateDialog] = useState(false);

    return (
        <div className={classes.contactListContainer}>
            <Grid container justifyContent="space-between" className={classes.reviewsTitle}>
                <Grid className={classes.reviewsTitle} item>Contact Information</Grid>
                <Grid item>
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => {
                            setOpenUpdateDialog(true);
                        }}>Add Contact</Button>
                </Grid>
            </Grid>
            {vendorContact?.length > 0 && (
                <Grid container spacing={2}>
                    {vendorContact.map((contact) => (
                        <VendorContact contact={contact} key={contact.id} hasPrimaryContact={hasPrimaryContact} />
                    ))}
                </Grid>
            )}
            {isLoadingVendorContact && <ShimmerLoader count={2} height="200" width={3} />}
            {!isLoadingVendorContact && !vendorContact?.length && <EmptyPlaceholder text="No Reviews Found" />}
            <UpdateContactDialog
                open={openUpdateDialog}
                onClose={() => setOpenUpdateDialog(false)}
                contact={{ vendorId: vendor?.id }}
                hasPrimaryContact={hasPrimaryContact} />

        </div>
    )
}
